import './horizontal-info.scss';

import { Collapse, Tooltip } from 'antd';

import { EOrganizationTypesCode } from '@/components/Shared/constants/dicts-codes';
import Chevron from '@/media/icons/chevron.svg?react';
import EditIcon from '@/media/icons/edit.svg?react';
import QuestionIcon from '@/media/icons/question-circle-outlined.svg?react';
import WarningIcon from '@/media/icons/warning-fill.svg?react';
import { getUserInitials } from '@/services/helpers/strings';
import { useAppSelector } from '@/store';

interface IProps {
  openEditModal?: () => void;
  setHistoryModal: (value: boolean) => void;
}

const HorizontalInfo: React.FC<IProps> = ({
  openEditModal,
  setHistoryModal
}) => {
  const { loan, orderApp, clientInfo, leasingOrder } = useAppSelector(
    (state) => state.newOrder
  );

  const shouldShowErrorPhone =
    !clientInfo?.isClientPhoneNumberVerified &&
    (orderApp?.status === 'draft' ||
      orderApp?.status === 'waiting_bank_response');

  const isIEOrOtherCompanyType =
    Number(orderApp?.personalInfo?.companyType) === EOrganizationTypesCode.IP ||
    Number(orderApp?.personalInfo?.companyType) ===
      EOrganizationTypesCode.Other;
  const isHasLeasing =
    orderApp?.sentTo === 'leasing' || orderApp?.sentTo === 'banks_leasing';
  const isIndividualEntrepreneur =
    leasingOrder?.isClientIpOwner && isHasLeasing && isIEOrOtherCompanyType;

  return (
    <div className="horizontal-info">
      <div className="horizontal-info__client">
        <div className="horizontal-info__name">
          <p className="horizontal-info__name-text">
            {getUserInitials(clientInfo)}{' '}
            {isIndividualEntrepreneur && (
              <span className="horizontal-info__individual-entrepreneur">
                (Оформитель ИП)
              </span>
            )}
          </p>

          {openEditModal && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                openEditModal();
              }}
              className="horizontal-info__edit"
            >
              <EditIcon />
            </button>
          )}
          <button
            onClick={(e) => {
              e.stopPropagation();
              setHistoryModal(true);
            }}
            className="horizontal-info__history"
          >
            <QuestionIcon />
          </button>
        </div>

        <p className="horizontal-info__person-id">
          ИИН: {clientInfo.iin},{' '}
          <span className="horizontal-info__phone-wrapper">
            <a
              className="horizontal-info__phone"
              href={`tel:${clientInfo.telNum.replace(/\(|\)|-|\s/g, '')}`}
            >
              {clientInfo.telNum}
            </a>
            {shouldShowErrorPhone && (
              <Tooltip title="Предоставленный клиентом номер не совпал с указанным в сервисе БМГ по ИИНу и возможны отказы по некоторым банкам">
                <WarningIcon className="horizontal-info__error-icon" />
              </Tooltip>
            )}
          </span>
        </p>
      </div>

      {orderApp?.status !== 'draft' && (
        <Collapse
          expandIconPlacement="end"
          className="horizontal-info__request"
          expandIcon={({ isActive }) => (
            <span
              className={`horizontal-info__arrow ${isActive ? 'horizontal-info__arrow--rotated' : ''}`}
            >
              <Chevron />
            </span>
          )}
          items={[
            {
              label: (
                <span className="horizontal-info__collapse-label">
                  {loan.auto || 'Запрошенные данные'}
                </span>
              ),
              children: (
                <div className="horizontal-info__request-list">
                  <p className="horizontal-info__request-item">
                    <b>Стоимость</b>
                    <span>{orderApp?.productInfo.product.costCar || '—'}</span>
                  </p>
                  <p className="horizontal-info__request-item">
                    <b>ПВ</b>
                    <span>{orderApp?.productInfo.product.initFee || '—'}</span>
                  </p>
                  <p className="horizontal-info__request-item">
                    <b>Сумма кредита</b>
                    <span>
                      {orderApp?.productInfo.product.requestAmount || '—'}
                    </span>
                  </p>
                  <p className="horizontal-info__request-item">
                    <b>Срок</b>
                    <span>
                      {(orderApp?.productInfo.product.loanTerm as number) || 0}{' '}
                      мес.
                    </span>
                  </p>
                </div>
              )
            }
          ]}
        />
      )}
    </div>
  );
};

export default HorizontalInfo;
